import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay } from "swiper/modules";
import { useTheme, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import sliderArrowIcon from "../assets/icons/top-slider-arrow-new.svg";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";


const SwiperContainer = styled('div')(({ theme }) => `
  /* @noflip */
  height: 100%;
  position: relative;
  padding-top: 10px;
  padding-left: 5px;
  padding-right: 5px;

/* Custom arrow icons */
 .swiper-button-next, .swiper-button-prev {
  background-image: url(${sliderArrowIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

    &:after {
      display: none;
    }
  }
 
 .swiper-button-next {
  transform: rotate(180deg); 
  }

  /* Custom arrow sizes */
  --swiper-navigation-size: 90px;
  --swiper-navigation-sides-offset: -5px;
  ${theme.breakpoints.down('sm')} {
    --swiper-navigation-size: 0;
  }

`);


const MediaCarousel = ({
  items,
  showNavigation = true,
  showPagination = true,
  onSlideClick,
  className,
  slidesPerView,
  direction = "horizontal",
  delay, // New prop for autoplay delay in milliseconds
}) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));

  // Configure autoplay settings if delay is provided
  const autoplayConfig = delay
    ? {
        delay,
        disableOnInteraction: false, // Continue autoplay after user interaction
        pauseOnMouseEnter: true, // Pause on mouse hover
      }
    : false;

  // Determine slides per view based on breakpoint or custom value
  const getSlidesPerView = () => {
    if (slidesPerView !== undefined) return slidesPerView;

    if (isXs) return 1;
    if (isSm) return 2;
    if (isMd) return 3;
    return 4; // default for lg and up
  };

  const renderMediaItem = (item) => {
    if (item.type === "video") {
      return (
        <iframe
          src={item.url}
          title={item.title || "Video content"}
          width="100%"
          height="100%"
          frameBorder="0"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }

    return (
      <img
        src={item.url}
        alt={item.title || "Image content"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    );
  };

  return (
    <SwiperContainer    >
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={30}
        slidesPerView={getSlidesPerView()}
        navigation={showNavigation}
        direction={direction}
        autoplay={autoplayConfig}
        className={className}
        pagination={
          showPagination
            ? {
                el: ".swiper-pagination",
                clickable: true,
                dynamicBullets: true,
              }
            : false
        }
        loop={true}
        style={{
          ...(direction === "vertical" && { height: "800px" }),
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide
            key={index}
            onClick={() => onSlideClick && onSlideClick(item, index)}
            style={{
              cursor: onSlideClick ? "pointer" : "default",
              ...(direction === "vertical" && { height: "auto" }),
            }}
          >
            {renderMediaItem(item)}
          </SwiperSlide>
        ))}
      </Swiper>
      {showPagination && (
        <div
          className="swiper-pagination"
          style={{
            bottom: "-30px",
          }}
        ></div>
      )}
    </SwiperContainer>
  );
};

export default MediaCarousel;
